import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { closeButton } from './Dialog.css';

export const DialogCloseButton = ({ onClose }: { onClose: () => void }): JSX.Element => (
  <button type="button" className={closeButton} onClick={onClose}>
    <FontAwesomeIcon size={'lg'} icon={faTimes} />
  </button>
);
